import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SvgIconComponent } from 'angular-svg-icon';
import { OverlayModule } from '@angular/cdk/overlay';
import { DecimalPipe } from '@angular/common';
import { CountdownComponent } from 'ngx-countdown';
import { CaptchaOverlayComponent } from '@core/components/captcha-overlay/captcha-overlay.component';
import { RainState } from '../rain.interface';
import { RainService } from '../rain.service';
import { ModalService } from '@core/modals/services/modal.service';

@Component({
  selector: 'app-rain-widget',
  imports: [
    SvgIconComponent,
    OverlayModule,
    DecimalPipe,
    CaptchaOverlayComponent,
    CountdownComponent,
  ],
  templateUrl: './rain-widget.component.html',
  styleUrl: './rain-widget.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RainWidgetComponent {
  rain = input.required<RainState>();
  isCaptchaOverlay = false;

  constructor(
    private rainService: RainService,
    private toastrService: ToastrService,
    private modalService: ModalService
  ) {}

  async handleVerifyCaptcha(captcha: string) {
    const message = await this.rainService.claimRain(captcha);
    this.toastrService.success(message);
    this.isCaptchaOverlay = false;
  }

  openCaptchaJoin() {
    if (!this.rain().captcha) {
      this.toastrService.error('Captcha loading error');
      return;
    }

    this.isCaptchaOverlay = true;
  }

  openTipRainModal() {
    this.modalService.openModal('TipRainModal');
  }
}
